import { render } from "./OffcanvasFinalizeCloseShiftForm.vue?vue&type=template&id=15b4fdcd"
import script from "./OffcanvasFinalizeCloseShiftForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasFinalizeCloseShiftForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__